import React, { useState, Fragment, useEffect } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { useQuery, useMutation } from "@apollo/client";

import {
  TabContent,
  TabPane,
  Modal,
  ModalBody,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardHeader,
  Button,
} from "reactstrap";
import classnames from "classnames";

import { GET_ORG_PROFILE, UPDATE_ORG_LOGO } from "../../../queries";
import addIcon from "../../../../src/assets/utils/images/add_icon.png";
import SettingOrgTab1 from "../ProfileOrg/SettingOrgTab1";
import SettingOrgTab2 from "../ProfileOrg/SettingOrgTab2";
import SettingOrgTab3 from "../ProfileOrg/SettingOrgTab3";
import SettingOrgTab4 from "../ProfileOrg/SettingOrgTab4";
import SettingOrgTab5 from "./Module/SettingOrgTab4";

import { useParams, useHistory } from "react-router-dom";
import animetionLogo from "../../../assets/utils/images/animetion_logo.gif";
import { useSettingOrgTab } from "../../../Layout/AppMain/SettingOrgTabContext";
import { useMyOrgInfo } from "../../../Layout/AppMain/LoginStatusContext";
import SettingTabOrgBusiness from "../ProfileOrg/SettingOrgTabBusiness";
import { sendGAEvent } from "../../../utils";
import DissolveBadge from "../../../components/DissolveBadge";

const SettingOrgInfoDashboard = ({ orgId, userRole, userId }) => {
  // if ("このユーザーは団体と紐づいていません" == orgId) {
  //   window.location.href = "/#/dashboards/faq";
  // }
  //useContext使用（タブのstate）
  const { orgActiveTab, setOrgActiveTab } = useSettingOrgTab();
  const myOrgInfo = useMyOrgInfo();
  const myOrgId = myOrgInfo.id;
  //タブ切り替え用
  const tabChangeToggle = (tab) => {
    if (orgActiveTab !== tab) setOrgActiveTab(tab);
  };

  //画像処理系
  const [updateLogo, { data: logoResult }] = useMutation(UPDATE_ORG_LOGO);
  const [logo, setLogo] = useState();
  const [modal, setModal] = useState(false);

  const modalToggle = () => {
    setModal(!modal);
  };

  const upload = async () => {
    await updateLogo({
      variables: { image: logo, userId: userId, orgPk: orgId },
    });
    await refetch();
    setModal(!modal);
  };

  const onSelectImageFile = (e) => {
    if (e.currentTarget.files !== null) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        setLogo({
          name: file.name,
          file: e.target.result,
        });
      };
      // 必須
      reader.readAsDataURL(file);
    }
  };

  //クエリ取得
  const { loading, error, data, refetch } = useQuery(GET_ORG_PROFILE, {
    variables: { id: orgId },
  });

  useEffect(() => {
    if (myOrgId || loading) {
    } else {
      alert(
        "このページを利用するには「組織登録」が必要です。\n詳しくはFAQをご覧ください。"
      );
      window.location.href = "/#/dashboards/faq";
    }
  }, []);

  useEffect(() => {
    const tab = localStorage?.getItem("tab");
    if (tab) {
      setOrgActiveTab(tab);
      localStorage.removeItem("tab");
      localStorage.removeItem("tabActive");
    } else return;
  }, []);

  useEffect(() => {
    if (orgActiveTab == 2) {
      sendGAEvent(
        "pageview",
        "/#/dashboards/plofile-organization/mission_and_collaboration_tab"
      );
    }
    if (orgActiveTab == 3) {
      sendGAEvent(
        "pageview",
        "/#/dashboards/plofile-organization/business_introduction_tab"
      );
    }
    if (orgActiveTab == 4) {
      sendGAEvent(
        "pageview",
        "/#/dashboards/plofile-organization/financial_data"
      );
    }
    if (orgActiveTab == 5) {
      sendGAEvent(
        "pageview",
        "/#/dashboards/plofile-organization/public_infomation_tab"
      );
    }
    if (orgActiveTab == 6) {
      sendGAEvent(
        "pageview",
        "/#/dashboards/plofile-organization/contract_and_member_tag"
      );
    }
  }, [orgActiveTab]);

  useEffect(() => {
    window.addEventListener("error", (e) => {
      if (
        e.message === "ResizeObserver loop limit exceeded" ||
        e.message ===
          "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
  }, []);

  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          alt="#"
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  if (error) {
    window.location.href = "/#/dashboards/journy";
  }

  const org_obj =
    data &&
    data.allOrgaccount &&
    data.allOrgaccount.edges[0] &&
    data.allOrgaccount.edges[0].node;

  // ローディング
  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          alt="#"
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  if (error) {
    alert("ログイン制限時間が切れました、再リロードしてください。");
    window.location.href = "/";
  }
  if (!data) {
    window.location.href = "/";
  }

  //全年度
  let all_fiscal_year =
    org_obj &&
    org_obj.annualData &&
    org_obj.annualData.edges &&
    org_obj.annualData.edges.map((array) => array.node.fiscalYear);

  if (all_fiscal_year) {
    all_fiscal_year.sort((a, b) => (a > b ? -1 : 1));
  } else {
  }

  //最新年度
  const default_fiscal_year = all_fiscal_year.slice()[0];

  return (
    <div>
      <Fragment>
        <CSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Card className="mb-3">
            <CardHeader className="org_title">
              {org_obj.logoUrl ? (
                <img
                  src={org_obj.logoUrl}
                  alt=""
                  className="profile-blur opacity-9"
                  style={{
                    width: "40px",
                    cursor: "pointer",
                    height: "40px",
                    backgroundSize: "content",
                    backgroundRepeat: "no-repeat",
                  }}
                  onClick={modalToggle}
                />
              ) : (
                <div>
                  <img
                    src={addIcon}
                    style={{ width: "55px", cursor: "pointer" }}
                    onClick={modalToggle}
                  />
                </div>
              )}
              <h4
                className="org_name"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                {org_obj.name}{" "}
                {org_obj.isDissolve && <DissolveBadge type="heading" />}
              </h4>
            </CardHeader>
          </Card>
          <Card className="mb-2 original-card__sp">
            <CardHeader className="card-header-tab">
              <Nav>
                <NavItem>
                  <NavLink
                    className={classnames({ active: orgActiveTab === "1" })}
                    onClick={() => {
                      tabChangeToggle("1");
                    }}
                  >
                    組織概要
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: orgActiveTab === "2" })}
                    onClick={() => {
                      tabChangeToggle("2");
                    }}
                  >
                    ミッションと連携方針
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: orgActiveTab === "3" })}
                    onClick={() => {
                      tabChangeToggle("3");
                    }}
                  >
                    事業紹介
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: orgActiveTab === "4" })}
                    onClick={() => {
                      tabChangeToggle("4");
                    }}
                  >
                    財務データ
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: orgActiveTab === "5" })}
                    onClick={() => {
                      tabChangeToggle("5");
                    }}
                  >
                    情報開示と第三者認証
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: orgActiveTab === "6" })}
                    onClick={() => {
                      tabChangeToggle("6");
                    }}
                  >
                    契約プランとメンバー
                  </NavLink>
                </NavItem>
              </Nav>
            </CardHeader>
          </Card>

          <TabContent activeTab={orgActiveTab} className="card-tab">
            <TabPane tabId="1">
              <SettingOrgTab1
                obj={org_obj}
                userId={userId}
                refetch={refetch}
                userRole={userRole}
                offices={org_obj.offices}
              />
            </TabPane>

            <TabPane tabId="2">
              <SettingOrgTab2
                loading={loading}
                obj={org_obj}
                userId={userId}
                refetch={refetch}
                userRole={userRole}
              />
            </TabPane>

            <TabPane tabId="3">
              <SettingTabOrgBusiness
                obj={org_obj}
                userId={userId}
                refetch={refetch}
                userRole={userRole}
              />
            </TabPane>

            <TabPane tabId="4">
              <SettingOrgTab3
                obj={org_obj}
                all_fiscal_year={all_fiscal_year}
                default_fiscal_year={default_fiscal_year}
                refetch={refetch}
                orgId={orgId}
              />
            </TabPane>

            <TabPane tabId="5">
              <SettingOrgTab4 obj={org_obj} orgPk={orgId} />
            </TabPane>

            <TabPane tabId="6">
              <SettingOrgTab5
                obj={org_obj}
                refetch={refetch}
                userRole={userRole}
              />
            </TabPane>
          </TabContent>
        </CSSTransitionGroup>
        <Modal isOpen={modal} toggle={modalToggle}>
          <ModalBody className="mt-4 ml-3 mr-3">
            <p className="bold">組織アイコンを登録</p>
            <input type="file" onChange={onSelectImageFile} />
          </ModalBody>
          <ModalFooter style={{ background: "#fff", borderTop: "none" }}>
            <Button onClick={upload} className="main_button">
              登録
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    </div>
  );
};

export default SettingOrgInfoDashboard;
